import { type ApiResponse } from '../apiResponse.types';

export interface ScriptType {
  id?: string;
  title: string;
  body: string;
  source: IntentSources;
  organizationId: string;
  updatedAt: string;
}

export interface IntentFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: 'create' | 'edit' | 'view';
  intent?: ScriptType | null;
  orgId?: string | null;
  onSave: () => Promise<void>;
  aiScriptFeatureFlag: boolean;
}

export interface ConfirmDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  intent: ScriptType;
  onDelete: () => Promise<ApiResponse<null>>;
}

export interface ScriptSketchProps {
  title: string;
  body: string;
}

export enum IntentSources {
  HUMAN = 'HUMAN',
  CHATGPT = 'CHATGPT'
}
